import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_topics_are_included_win_the_facs_written_12'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_topics_are_included_win_the_facs_written_12',
  name: "Which of the following topics are included within the facility's written policies and procedures for domestic migrant workers?",
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'RECRUITMENT_FEES_AND_EXPENSES',
      text: 'Recruitment fees and expenses',
      externalIds: [
        {
          id: 'ms-pla-32x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EMPLOYMENT_CONTRACTS',
      text: 'Employment contracts',
      externalIds: [
        {
          id: 'ms-pla-33x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DEPOSITS',
      text: 'Deposits',
      externalIds: [
        {
          id: 'ms-pla-34x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WAGES_AND_BENEFITS',
      text: 'Wages and benefits',
      externalIds: [
        {
          id: 'ms-pla-35x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKING_HOURS',
      text: 'Working Hours',
      externalIds: [
        {
          id: 'ms-pla-36x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ACCOMMODATIONS',
      text: 'Accommodations',
      externalIds: [
        {
          id: 'ms-pla-37x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FREEDOM_OF_MOVEMENT',
      text: 'Freedom of movement',
      externalIds: [
        {
          id: 'ms-pla-38x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_IN_EMPLOYMENT',
      text: 'Non-discrimination in employment',
      externalIds: [
        {
          id: 'ms-pla-39x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HARASSMENT_AND_ABUSE_IN_EMPLOYMENT',
      text: 'Harassment and abuse in employment',
      externalIds: [
        {
          id: 'ms-pla-40x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DISCIPLINE_IN_EMPLOYMENT',
      text: 'Discipline in employment',
      externalIds: [
        {
          id: 'ms-pla-41x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'END_OF_EMPLOYMENT',
      text: 'End of employment',
      externalIds: [
        {
          id: 'ms-pla-42x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'REQUIREMENTS_FOR_LABOR_AGENTS_BROKERS',
      text: 'Requirements for labor agents/brokers',
      externalIds: [
        {
          id: 'ms-pla-43x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-pla-44x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-pla-45f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'RECRUITMENT_FEES_AND_EXPENSES',
                'EMPLOYMENT_CONTRACTS',
                'DEPOSITS',
                'WAGES_AND_BENEFITS',
                'WORKING_HOURS',
                'ACCOMMODATIONS',
                'FREEDOM_OF_MOVEMENT',
                'NON_DISCRIMINATION_IN_EMPLOYMENT',
                'HARASSMENT_AND_ABUSE_IN_EMPLOYMENT',
                'DISCIPLINE_IN_EMPLOYMENT',
                'END_OF_EMPLOYMENT',
                'REQUIREMENTS_FOR_LABOR_AGENTS_BROKERS',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-pla-31',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 20240,
  sectionId: '2.2.6.10',
  impactArea: 'Policies and Procedures',
  impactAreaId: 'POLICIES_AND_PROCEDURES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
